<template>
    <div>
      <Header title="学者库" @filtrate='filtrate' />
      <Contentslist v-if="!isHot" />
      <Filtrate v-if="isHot" @closeTheScreen="closeTheScreen" />
    </div>
</template>

<script>
import Header from '@/views/mobileView/home/homePageFeatures/components/Header.vue'
import Contentslist  from '@/views/mobileView/home/homePageFeatures/academicLibraries/components/Contentslist.vue'
import Filtrate  from '@/views/mobileView/home/homePageFeatures/academicLibraries/components/Filtrate.vue'
export default {
     name:'index',
    components: {
      Header,
      Contentslist,
      Filtrate
    },
    props: {

    },
    data() {
        return {
          isHot:false,
        };
    },
    computed: {

    },
    watch: {

    },
    created() {

    },
    mounted() {

    },
    methods: {
      filtrate() {
        this.isHot = true
      },
      closeTheScreen() {
        this.isHot = false
      },
    },
};
</script>

<style scoped lang="scss">
</style>
